<template>
  <div>
    <b-card header="Analisa Kasus Materi " sub-title="">
      <b-alert variant="danger" show>
        <div class="alert-body">
          <span>Penggunaan AI (Kecerdasan Buatan) dalam pengerjaan analisa kasus akan mengakibatkan diskualifikasi</span>
        </div>
      </b-alert>

      <validation-observer v-slot="{ handleSubmit }">
        <b-form @submit.prevent="handleSubmit(onSubmit)">
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Kode Test *"
              >
                <validation-provider v-slot="{ errors }" name="Kode Tes" rules="required"
                      :messages="{
                        required: 'Bagian ini wajib diisi'
                      }">
                  <b-form-input v-model="form.kode" id="kode"></b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="6">
              <b-form-group
                label="Nomor Ujian *"
              >
                <validation-provider v-slot="{ errors }" name="Nomor Ujian" rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }">
                  <b-form-input v-model="form.nomor_ujian" id="nomor_ujian" readonly></b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Editor Analisa Kasus -->
          <b-row class="mt-2">
            <b-col md="12">
              <b-form-group
                label="Analisa Kasus *"
                label-for="analisa-kasus"
                invalid-feedback="Analisa kasus harus diisi"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Analisa Kasus"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <quill-editor
                    id="analisa-kasus"
                    v-model="form.analisa_kasus"
                    :options="{
                      modules: {
                        toolbar: [
                          ['bold', 'italic', 'underline'],
                          [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                          ['link', 'code-block']
                        ]
                      }
                    }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Tombol -->
          <b-row class="mt-1">
            <b-col cols="12">
              <b-button type="submit" variant="primary" class="mr-1">Simpan</b-button>
            </b-col>
            <b-col cols="12"><small>
            Analisa kasus Anda akan disimpan jika kode test sesuai</small></b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import {
  required,
  integer,
  regex,
  confirmed,
  // min,
  // max,
  email
} from '@validations'
extend('required', {
    ...required,
    message: 'Bagian ini wajib diisi',
});

import {
  BCard,
  BAlert,
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormRadioGroup,
  BFormTextarea,
  BButton,
  BFormDatepicker,
  BMedia, BMediaAside, BMediaBody,
  BFormFile,
  BImg,
  BFormSelect,
  BTable,
  BLink,
} from 'bootstrap-vue';
import {
  getLembarKehidupan,
} from '@/connection-api/lembarkehidupan'
import {
  postAnalisaKasusKompetensiDasar,
} from '@/connection-api/kompetensidasar'

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    BAlert,
    BCard,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormRadioGroup,
    BFormTextarea,
    BButton,
    BFormDatepicker,
    BMedia, BMediaAside, BMediaBody,
    BFormFile,
    BImg,
    BFormSelect,
    BTable,
    BLink,
    quillEditor,
  },
  data() {
    return {
      required,
      integer,
      regex,
      confirmed,
      // min,
      // max,
      email,
      form: {
        kode: '',
        nomor_ujian: '',
        analisa_kasus: '',
      },
    };
  },
  mounted() {
    this.getLembarKehidupan();
  },
  methods: {
    async getLembarKehidupan(){
      const response = await getLembarKehidupan();
      if (response.data) {
        this.form.nomor_ujian = response.data.data.nomor_ujian;
      }
    },
    async onSubmit() {
      // Lakukan sesuatu ketika formulir disubmit
      const response = await postAnalisaKasusKompetensiDasar(this.form)
        .then(response => {
          if (response.data.status.code === '00') {
            this.$bvModal.msgBoxOk('Analisa kasus berhasil disimpan.', {
              title: 'Sukses',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'success',
              headerClass: 'p-2 border-bottom-0',
              footerClass: 'p-2 border-top-0',
              hideHeaderClose: false
            });
          } else {
      
            this.$bvModal.msgBoxOk(response.data.status.message, {
              title: 'Gagal',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'danger',
              headerClass: 'p-2 border-bottom-0',
              footerClass: 'p-2 border-top-0',
              hideHeaderClose: false
            });
          }
        });

    },
    handleReset() {
      // Lakukan reset formulir
    }
  }
};
</script>
<style scoped>
.icon-size {
  width: 32px;
  /* Set your desired width */
  height: 32px;
  /* Set your desired height */
}
</style>